import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "sonner";
import Home from "@/pages/Home";
import AboutUs from "@/pages/AboutUs";
import ServicesIndex from "@/pages/ServicesIndex";
import ServiceDetail from "@/pages/ServiceDetail";
import AccessibilityStatement from "@/pages/AccessibilityStatement";
import AccessibilityWidget from "@/components/AccessibilityWidget";
import MobileStickyCta from "@/components/MobileStickyCta";

function App() {
  return (
    <HelmetProvider>
      <div className="App pb-20 md:pb-0">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about-us" element={<AboutUs />} />
            <Route path="/services" element={<ServicesIndex />} />
            <Route path="/services/:slug" element={<ServiceDetail />} />
            <Route path="/accessibility-statement" element={<AccessibilityStatement />} />
          </Routes>
          <AccessibilityWidget />
          <MobileStickyCta />
          <Toaster position="top-right" richColors closeButton />
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
